import React from 'react';

import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll";
import ProjectSession from "../../../../../model2/project/project-session";
import {ReassignmentDataType, USER_VIEW_TYPE} from "../../../@type";
import ProjectUserFull from "../../../../../model2/project-user/project-user-full";
import {ProjectRole} from "../../../../../gd/const/project";
import UserAssignment_Collection from "../../../model/collection";
import UserAssignment from "../../../model/user-assignment";
import UserReassignForm from "./form/form";
import Button, {ButtonType} from "../../../../../gd-components/buttons/gd-button/gd-button-ui5-new";
import FormsCallbackManager from "../../manager/forms-callback-manager";
import ProjectUsersFullCollection from "../../../../../model2/project-user/collection-full";
import ModalProjectTeamActions from "../../actions/team-actions";
import Team from "../../../../../model2/team/team";
import ProjectTeamUser_checkDelete from "../../actions/check-project-team-user-delete";
import UserIcon from "../../../../../gd-components/icons/user/user";
import User from "../../../../../model2/user/user";
import ProjectUserSession from "../../../../../model2/project-user/project-user-session";

type Props = {
    reassignType        : USER_VIEW_TYPE
    userAssignments     : UserAssignment_Collection
    projectUser         : ProjectUserFull
    projectUsers        : ProjectUsersFullCollection
    actions             : ModalProjectTeamActions
    onCloseModal        : callback
}

export default class ReassignUsersView extends React.Component<Props> {

    public userOptions          : Options
    public formsCallbackManager : FormsCallbackManager // Tut sobiraetsya triggerOnSubmit callbacks i submitData dlya UserReassignForm
    public collection           : UserAssignment_Collection

    constructor(props: Props) {
        super(props);

        this.formsCallbackManager   = new FormsCallbackManager()

        // Group and convert to collection
        this.collection             = this.props.userAssignments;

        // Tut
        this.userOptions = _(gd.session.projectUsers.filterByProjectNotReadOnly(this.props.projectUser.projectId).models)
            .filter((projectUser: ProjectUserSession)=> {
                return projectUser.projectRole === ProjectRole.OWNER || !this.props.projectUser.team.userIds.includes(projectUser.userId);
            })
            .map(projectUser=>({
                value: projectUser.user.id,
                label: projectUser.user.name
            }))
            .value();
    }

    getInfo() {
        let res;

        const project: ProjectSession | null = gd.session.projects.get(this.props.projectUser.projectId);
        const team: Team = this.props.projectUser.team

        switch (this.props.reassignType) {
            case 'reassign-delete':
                res = (
                    <div className="ui5-plate plate-error flex-row-left-top p-l-15 p-r-15">
                        <div className="flex-row-left-top w-60">
                            <div className="i5-emergency-solid ui5-color-red fs-32 m-t-4"></div>
                        </div>
                        <div>
                            <p>You are about to delete <b>{team.name}</b> from <b>{project?.name}</b> project.</p>
                            <p className="m-t-10">Some team users have open items that you need to re-assign to another project
                                user before deleting.</p>
                        </div>
                    </div>
                );
                break;
            case 'reassign-access':
                res = (
                    <div className="ui5-plate plate-error flex-row-left-top p-l-15 p-r-15">
                        <div className="flex-row-left-top w-60">
                            <div className="i5-emergency-solid ui5-color-red fs-32 m-t-4"></div>
                        </div>
                        <div>
                            <p>You are about to set the read-only access level
                                for <b>{team.name}</b> in <b>{project?.name}</b> project.</p>
                            <p className="m-t-10">Please re-assign active tasks/events/projects if applicable and click
                                reassign button.</p>
                        </div>
                    </div>
                );
                break;
        }
        return res;
    }

    runFormCallbacks = async ()=> {

        // Reset forms data
        this.formsCallbackManager.submitData.reset()
        this.formsCallbackManager.isFormsValid = true

        await this.formsCallbackManager.runAsync()


        if (this.formsCallbackManager.isFormsValid) {

            this.props.userAssignments.reset(this.formsCallbackManager.submitData.models)

            return this.props.actions.reassignTeamItems(this.props.userAssignments)
            // return this.props.actions.reassignTeamItems(this.formsCallbackManager.submitData)
        }
    }

    render() {

        let submitLabel = '';
        switch (this.props.reassignType) {
            case 'reassign-delete': submitLabel = 'Reassign & Delete'; break;
            case 'reassign-access': submitLabel = 'Reassign & Update'; break;
        }

        return (
            <div className="flex-columns-top-bottom h-100p">

                <div className="flex-row-right-center">
                    <div className="i5-delete m-t-10 m-r-10" onClick={this.props.onCloseModal}/>
                </div>

                <div className="ui5-title-app-name p-l-25 p-r-25 m-b-15">Delete Users</div>

                <VScroll style={{ height: "calc(100% - 150px)"}}>
                    <div className="big-panel p-l-25 p-r-25 p-b-25 m-t-10">
                        {this.getInfo()}

                        {this.collection.models.map((model: UserAssignment, key: number)=> {

                            const {noAssignments, canDelete, reasonCantDelete, message} = ProjectTeamUser_checkDelete(this.props.projectUser, model, this.props.projectUsers)

                            const user: User | null = gd.session.users.get(model.userId);

                            if (!canDelete) {
                                return (
                                    <div key={key}>
                                        <div className="flex-row-left-center m-t-25">
                                            <UserIcon className="m-r-10" size="26" userId={model.userId}/>
                                            <div className="ui5-title-small">{user?.name}</div>
                                        </div>
                                        <div className="ui5-txt-red ui5-txt-not-important-small m-t-20 m-r-20"
                                             style={{marginLeft: 36}}>
                                            {reasonCantDelete}
                                        </div>
                                    </div>
                                )
                            }

                            if (canDelete && noAssignments) {
                                return (
                                    <div key={key}>
                                        <div className="flex-row-left-center m-t-25">
                                            <UserIcon className="m-r-10" size="26" userId={model.userId}/>
                                            <div className="ui5-title-small">{user?.name}</div>
                                        </div>

                                        <div className="ui5-txt-not-important-small m-t-20 m-r-20"
                                             style={{marginLeft: 36}}>
                                            {message}
                                        </div>
                                    </div>
                                )
                            }

                            return <UserReassignForm key                    = {key}
                                                     user                   = {user}
                                                     model                  = {model}
                                                     formsCallbackManager   = {this.formsCallbackManager}
                                                     userOptions            = {this.userOptions}/>
                        })}

                    </div>
                </VScroll>
                <div className="modal-submit flex-row-center-top fl-gap-8">
                    <Button className   = "m-r-15 red"
                            label       = {submitLabel}
                            type        = {ButtonType.SECONDARY}
                            onClick     = {this.runFormCallbacks}/>
                    <Button label   = "No, cancel"
                            type    = {ButtonType.WHITE}
                            onClick = {this.props.onCloseModal}/>
                </div>
            </div>
        );
    }
}
